import { inject } from 'aurelia-framework';
import { EventAggregator } from 'aurelia-event-aggregator';
import { MaterialService } from 'pages/system-fields/materials/service';
import { DialogService } from 'aurelia-dialog';
import { formatTableLink, creatTableButton } from 'resources/utility';
import toastr from 'toastr';

@inject(MaterialService, DialogService, EventAggregator)
export class Materials {
    constructor(materialService, dialogService, ea) {
        this.ea = ea;
        this.materialService = materialService;
        this.dialogService = dialogService;

        this.columns = [
            { dataField: 'name', sortOrder: 'asc', cellTemplate: (container, options) => formatTableLink({ container, containerOptions: options, callback: this.edit }) },
            { caption: 'Actions', cellTemplate: (container, options) => creatTableButton({ container, containerOptions: options, style: 'danger', label: 'Delete', action: this.delete }), allowExporting: false }
        ];

        this.subscription = this.ea.subscribe('materials:updated', () => {
            this.grid.refresh();
        });
    }

    deactivate () {
        this.subscription.dispose();
    }

    delete = (material) => {
        this.dialogService.open({ viewModel: PLATFORM.moduleName('resources/elements/modals/confirm/index') }).whenClosed(async response => {
            if (!response.wasCancelled) {
                await this.materialService.delete(material.id);
                this.grid.refresh();
                toastr.success('Material was deleted!');
            }
        });
    };

    add() {
        this.dialogService.open({ viewModel: this.materialService.editor });
    }

    edit = (data) => {
        this.dialogService.open({ viewModel: this.materialService.editor, model: { id: data.id } });
    };
}